var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EAEDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 28,
    height: 15,
    rx: 2,
    fill: "#26B634"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 23L13.8 20.24L15.77 23H17.12L14.5 19.39L16.97 16H15.62L13.8 18.53L11.98 16H10.63L13.09 19.39L10.48 23H11.83ZM17.9516 16V23H22.7716V21.94H19.0916V16H17.9516ZM23.3921 17.78C23.3921 20.26 27.3921 19.6 27.3921 21.22C27.3921 21.88 26.7221 22.09 25.8221 22.09C25.0221 22.09 24.1821 21.89 23.4221 21.4V22.52C24.1121 22.91 24.9621 23.13 25.9021 23.13C27.3021 23.14 28.5521 22.63 28.5521 21.16C28.5521 18.66 24.5521 19.27 24.5521 17.76C24.5521 17.16 25.0921 16.91 25.9421 16.91C26.6921 16.9 27.4721 17.11 28.0421 17.49V16.4C27.4721 16.07 26.6521 15.87 25.8521 15.87C24.5321 15.87 23.3921 16.49 23.3921 17.78Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.b652e37697fff944e15ee61aca70c517.svg";
export { ForwardRef as ReactComponent };